(function() {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    /**
     * @ngdoc controller
     * @name ihh-common-web.formUpdateController
     * @requires $rootScope
     * @requires $scope
     * @requires alertConstants
     * @requires formUpdateUtilities
     *
     * @description
     *  This controller manages the user interactions with the save/cancel
     *  buttons. Initialized with the formUpdateControlsDirective
     */
    angular
        .module('ihh-common-web')
        .controller('formUpdateCtrl', formUpdateCtrl);

    formUpdateCtrl.$inject = ['$rootScope', '$scope', 'alertConstants', 'formUpdateUtilities'];

    function formUpdateCtrl($rootScope, $scope, alertConstants, formUpdateUtilities) {
        activate();

        function activate() {
            var saveFnLabelDefault = 'Save';
            var cancelFnLabelDefault = 'Cancel';
            var glyphiconClassDefault = 'glyphicon-floppy-disk';

            if (!$scope.saveFnLabel) {
                $scope.saveFnLabel = saveFnLabelDefault;
            }

            if (!$scope.cancelFnLabel) {
                $scope.cancelFnLabel = cancelFnLabelDefault;
            }

            if (!$scope.saveGlyphiconClass) {
                $scope.saveGlyphiconClass = glyphiconClassDefault;
            }
        }


            /**
             * @ngdoc method
             * @name saveSequence
             * @memberOf ihh-common-web.formUpdateController
             *
             * @description
             *  This method handles the save sequence for the formUpdateDirective.
             *  Will update banner if invalid, and execute callback if valid.
             *
             * @param {object} form the form where the function call originated
             * @param {function} callback the function to call if the form is valid
             * @param {object} prescriptionForm the optional prescriptionForm
             * @returns {undefined}
             */
        $scope.saveSequence = function(form, callback, prescriptionForm) {
            if (form.$invalid) {

                var invalidFieldIds = formUpdateUtilities.generateInvalidFieldsArray(form.$name, $scope.ihhFormIgnores);
                var alertMessage;

                if (invalidFieldIds.length === 2) {
                    alertMessage = invalidFieldIds[0] + ' and ' + invalidFieldIds[1];
                }
                else {
                    alertMessage = window.compoundSubject(invalidFieldIds).delimitAll().make();
                }

                $rootScope.$broadcast('updateAlertBanner', {
                    key: alertConstants.levels.warning.key,
                    messageType: alertConstants.types.form.key,
                    message: alertMessage,
                    callerName: form.$name
                });
            }
            else {
                $rootScope.$broadcast('hideAlertBanner');

                if (angular.isDefined(prescriptionForm)) {
                    callback(prescriptionForm.rxTemp, prescriptionForm);
                }
                else {
                    callback();
                }
            }
        };

            /**
             * @ngdoc method
             * @name cancelSequence
             * @memberOf ihh-common-web.formUpdateController
             *
             * @description
             *  This method handles the cancel sequence for the formUpdateDirective.
             *  Will hide the banner and call the callback function
             *
             * @param {object} form the form where the function call originated
             * @param {function} callback
             * @param {object} prescriptionForm the optional prescriptionForm
             * @returns {undefined} the function to call if the form is valid
             */
        $scope.cancelSequence = function(form, callback, prescriptionForm) {
            $rootScope.$broadcast('hideAlertBanner', {});

            if (angular.isDefined(prescriptionForm)) {
                callback(prescriptionForm);
            }
            else {
                callback();
            }
        };
    }

})();